import { forwardRef, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import { Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';
import { Properties as TypeCSSProperties } from 'csstype';
import styled from 'styled-components';

export interface TextCSSOverrideProps {
  color?: TypeCSSProperties['color'];
  fontFamily?: TypeCSSProperties['fontFamily'];
  fontSize?: TypeCSSProperties['fontSize'];
  fontStyle?: TypeCSSProperties['fontStyle'];
  fontWeight?: TypeCSSProperties['fontWeight'];
  letterSpacing?: TypeCSSProperties['letterSpacing'];
  lineHeight?: TypeCSSProperties['lineHeight'];
  textDecoration?: TypeCSSProperties['textDecoration'];
  textTransform?: TypeCSSProperties['textTransform'];
}

interface TextWrapperProps {
  typographyProps?: TypographyProps<
    any,
    {
      component?: any;
    }
  >;
  formattedMessageProps?: FormattedMessageProps;
  cssProps?: TextCSSOverrideProps;
  className?: string;
  children?: ReactNode;
}

const StyledText = styled(Typography)<TextWrapperProps['typographyProps'] & { $cssProps: TextCSSOverrideProps }>`
  &.text-component {
    color: ${({ $cssProps }) => $cssProps && $cssProps.color};
    font-family: ${({ $cssProps }) => $cssProps && $cssProps.fontFamily};
    font-size: ${({ $cssProps }) => $cssProps && $cssProps.fontSize};
    font-style: ${({ $cssProps }) => $cssProps && $cssProps.fontStyle};
    font-weight: ${({ $cssProps }) => $cssProps && $cssProps.fontWeight};
    letter-spacing: ${({ $cssProps }) => $cssProps && $cssProps.letterSpacing};
    line-height: ${({ $cssProps }) => $cssProps && $cssProps.lineHeight};
    text-decoration: ${({ $cssProps }) => $cssProps && $cssProps.textDecoration};
    text-transform: ${({ $cssProps }) => $cssProps && $cssProps.textTransform};
  }
`;

export const TextWrapper = forwardRef<HTMLSpanElement, TextWrapperProps>(
  ({ typographyProps, formattedMessageProps, cssProps, children, className, ...forwardedProps }, ref) => {
    const { defaultMessage, id } = formattedMessageProps || {};

    return (
      <StyledText
        {...forwardedProps}
        ref={ref}
        {...typographyProps}
        $cssProps={cssProps}
        className={clsx('text-component', className)}
      >
        {id || defaultMessage ? <FormattedMessage {...formattedMessageProps} /> : children}
      </StyledText>
    );
  }
);
